import HiddenNav from "../../classes/HiddenNav";
import {initMapContainer, MAP_REQUIRED_CLASS} from "../../elements/div.map/index";

const initLazyMap = ( component ) => {
	const mapContainer = component.querySelector(`div.map.${MAP_REQUIRED_CLASS}`);
	const acceptableOffset = 100;
	
	if ( !mapContainer )
	{
		return;
	}
	
	const loadMap = () => {
		const mapContainerRect = mapContainer.getBoundingClientRect();
		
		if (
			mapContainer.classList.contains( MAP_REQUIRED_CLASS )
			&& mapContainerRect.y <= ( window.innerHeight + acceptableOffset ) )
		{
			mapContainer.classList.remove( MAP_REQUIRED_CLASS );
			initMapContainer( mapContainer );
		}
	};
	
	window.addEventListener( 'scroll', loadMap );
	window.addEventListener( 'resize', loadMap );
	
	loadMap();
};

export const initSectionInfrastructure = () => {
	const components = Array.from( document.querySelectorAll(`section.infrastructure`));

	if ( components.length )
	{
		components.forEach( ( component ) => {
			const filters = component.querySelector(`div.map div.filters ul`);
			
			if ( filters )
			{
				const hiddenNavInstance = new HiddenNav( filters );

				hiddenNavInstance.init( window.innerWidth >= 956 );

				const windowResizeHandler = () => {
					if ( window.innerWidth >= 956 && !hiddenNavInstance.isHiding() )
					{
						hiddenNavInstance.startHiding();
					}

					if ( window.innerWidth < 956 && hiddenNavInstance.isHiding() )
					{
						hiddenNavInstance.stopHiding();
					}
				};
				
				const filtersClickHandler = ({target}) => {
					if ( target.closest(`li.hidden-navs`) )
					{
						hiddenNavInstance.destroy( () => window.removeEventListener( `resize`, windowResizeHandler) );
						filters.classList.add(`filters--wrap`);
						filters.removeEventListener(`click`, filtersClickHandler);
					}
				};
				
				window.addEventListener( `resize`, windowResizeHandler);
				filters.addEventListener(`click`, filtersClickHandler);
			}
			
			initLazyMap( component );
		});
	}
};
